import React, {Fragment, useMemo, useState, useEffect} from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {connect} from 'react-redux';
import EnhancedModal from "../../../../../components/enhanced-modal";
import {
    GUTTER_MD,
    SPAN_FULL,
    SPAN_TWO_QUARTERS,
    MARGIN_MD,
    SPAN_ONE_QUARTER,
    GUTTER_XS,
    SPAN_THREE_QUARTERS,
    MARGIN_XS, SPAN_HALF,
    PADDING_XS,
    PADDING_SM,
    GUTTER_SM
} from "../../../../../styles/constants";
import {
    clearTranscodingUI,
    deleteDSDValueComponentToTable,
    deleteDimensionTranscoding,
    getCodeMatch,
    getDataFromCodelist,
    getDataFromDataset,
    hideTranscodingSettingsWithoutTimeDimension,
    importTranscodingFromCsvFile,
    saveDimensionTranscoding,
    setTranscodingMode,
    showDsdComponentModal
} from "../actions";
import {Button, Card, Col, Modal, Row, Select, Tooltip} from "antd";
import Call from "../../../../../hocs/call";
import FileInput from "../../../../../components/file-input";
import _ from "lodash";
import DSDComponentModal from "./DSDComponentModal";
import RulesTableTranscoding from "./RulesTable";
import {DataLanguageConsumer} from "../../../../../contexts/DataLanguage";
import {downloadCSVFile, handleFileUpload} from "../../utils";

const mapStateToProps = state => ({
    appLanguage: state.app.language,
    showTranscodingSettingsWithoutTimeDimension: state.scenes.mappingHandler.mappingSet.transcoding.showTranscodingSettingsWithoutTimeDimension,
    data: state.scenes.mappingHandler.mappingSet.transcoding.data,
    selectedDataset: state.scenes.mappingHandler.mappingSet.wizard.selectedDataset,
    selectedMappingSet: state.scenes.mappingHandler.mappingSet.wizard.selectedMappingSet,
    columnDataset: state.scenes.mappingHandler.mappingSet.transcoding.columnDataset,
    columnCodelist: state.scenes.mappingHandler.mappingSet.transcoding.columnCodelist,
    dataTable: state.scenes.mappingHandler.mappingSet.transcoding.dataTable,
    mode: state.scenes.mappingHandler.mappingSet.transcoding.mode,
})

const mapDispatchToProps = dispatch => ({
    onHideTranscodingSettingsWithoutTimeDimension: () => dispatch(hideTranscodingSettingsWithoutTimeDimension()),
    onGetDataFromDataset: ({entityId, columns}) => dispatch(getDataFromDataset(entityId, columns)),
    onGetDataFromCodelist: (triplet) => dispatch(getDataFromCodelist(triplet)),
    onSetTrancodingMode: (mode) => dispatch(setTranscodingMode(mode)),
    onClearTranscoding: () => dispatch(clearTranscodingUI()),
    onShowDsdComponentModal: (index) => dispatch(showDsdComponentModal(index)),
    onDeleteDsdComponentToRow: (index) => dispatch(deleteDSDValueComponentToTable(index)),
    onImportTranscodingCSV: (csvData, t) => dispatch(importTranscodingFromCsvFile(csvData, t)),
    onSaveTranscoding: (data, dataTable) => dispatch(saveDimensionTranscoding(data, dataTable)),
    onDeleteTranscoding: (data, transcodingEntityId) => dispatch(deleteDimensionTranscoding(data, false)),
    onCodeMatch: (dataTable,triplet, columnName) => dispatch(getCodeMatch(dataTable.map(x => x[columnName]),triplet, columnName))
})

const isSaveButtonDisabled = (dataTable) => {
    return dataTable !== null && dataTable !== undefined ? dataTable.find(row => !!row.Component) : null
}

const TranscodingDimension = ({
                                  t,
                                  appLanguage,
                                  showTranscodingSettingsWithoutTimeDimension,
                                  onHideTranscodingSettingsWithoutTimeDimension,
                                  onGetDataFromDataset,
                                  data,
                                  onGetDataFromCodelist,
                                  selectedDataset,
                                  columnDataset,
                                  columnCodelist,
                                  onCodeMatch,
                                  onClearTranscoding,
                                  onSetTrancodingMode,
                                  mode,
                                  onImportTranscodingCSV,
                                  onSaveTranscoding,
                                  onDeleteTranscoding,
                                  dataTable
                              }) => {

    const [csvData, setCSVData] = useState([]);
    const [fileName, setFileName] = useState(null);
    const [languageSelector, setLanguageSelector] = useState(appLanguage);

    useEffect(() => {
        setCSVData(csvData)
    }, [csvData]);

    const entityId = useMemo(() => {
        return !!selectedDataset ? selectedDataset.id : null
    }, [selectedDataset]);

    const columns = useMemo(() => {
        return !!data ? data.columnName : null
    }, [data]);

    const triplet = useMemo(() => {
        return !!data ? data.dsdCodelist : null
    }, [data]);

    return (<DataLanguageConsumer>
        {dataLanguage => {
            dataLanguage = languageSelector
            return (
                <Fragment>
                    <Call cb={onGetDataFromCodelist}
                          cbParam={triplet}
                          disabled={!data || !triplet || !!columnCodelist || !showTranscodingSettingsWithoutTimeDimension}
                    >
                        <Call cb={onGetDataFromDataset}
                              cbParam={{entityId, columns}}
                              disabled={!data || !entityId || !!columnDataset || !showTranscodingSettingsWithoutTimeDimension || !columnCodelist}
                        >
                            <EnhancedModal
                                title={t('scenes.mappingHandler.MappingSet.transcoding.title')}
                                visible={showTranscodingSettingsWithoutTimeDimension}
                                fullscreen
                                withDataLanguageSelector
                                onDataLanguageSelectorChange={
                                    (lang, changelang) => {
                                        setLanguageSelector(lang)
                                        changelang()
                                    }
                                }
                                onCancel={() => {
                                    setCSVData([]);
                                    setFileName(null);
                                    onHideTranscodingSettingsWithoutTimeDimension();
                                }}
                                footer={
                                    <Row type="flex" justify="end" align="middle" gutter={GUTTER_SM}>
                                        <Col>
                                            <Tooltip
                                                title={t("scenes.mappingHandler.MappingSet.transcoding.tooltip.deleteTranscodingButton")}>
                                                <Button
                                                    icon="delete"
                                                    disabled={!!data && !data.transcoding}
                                                    onClick={() => {
                                                        Modal.confirm({
                                                            title: t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcoding.modals.transconding.modalConfirm.title.deleteTranscoding"),
                                                            content: t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcoding.modals.transconding.modalConfirm.content.deleteTranscoding"),
                                                            onOk() {
                                                                setCSVData([]);
                                                                setFileName(null);
                                                                onDeleteTranscoding(data, data.transcoding.entityId);
                                                                onHideTranscodingSettingsWithoutTimeDimension();
                                                            },
                                                            cancelText: t('commons.buttons.cancel.title')
                                                        })
                                                    }}
                                                >
                                                    {t('scenes.mappingHandler.MappingSet.transcoding.buttons.delete')}
                                                </Button>
                                            </Tooltip>
                                        </Col>
                                        <Col>
                                            <Button
                                                onClick={() => {
                                                    setCSVData([]);
                                                    setFileName(null);
                                                    onHideTranscodingSettingsWithoutTimeDimension()
                                                }}
                                            >
                                                {t('commons.buttons.close.title')}
                                            </Button>
                                        </Col>
                                        <Col>
                                            <Button
                                                type="primary"
                                                disabled={!isSaveButtonDisabled(dataTable)}
                                                onClick={() => {
                                                    Modal.confirm({
                                                        title: t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcoding.modals.transconding.modalConfirm.title.saveTranscoding"),
                                                        content: t("scenes.dataManager.dataflowBuilder.list.actions.productionModal.transcoding.modals.transconding.modalConfirm.content.saveTranscoding"),
                                                        onOk() {
                                                            setCSVData([]);
                                                            setFileName(null);
                                                            onSaveTranscoding(data, dataTable);
                                                            onHideTranscodingSettingsWithoutTimeDimension();
                                                        },
                                                        cancelText: t('commons.buttons.cancel.title')
                                                    })
                                                }}
                                            >
                                                {t('commons.buttons.save.title')}
                                            </Button>
                                        </Col>
                                    </Row>
                                }
                            >
                                <Row align="middle" type="flex" style={{marginBottom: MARGIN_MD}}>
                                    <Col span={SPAN_TWO_QUARTERS}>
                                        <Tooltip
                                            title={t("scenes.mappingHandler.MappingSet.transcoding.tooltip.clearTranscodingButton")}>
                                            <Button icon="delete"
                                                    onClick={onClearTranscoding}>{t('scenes.mappingHandler.MappingSet.transcoding.buttons.clear')}</Button>
                                        </Tooltip>
                                    </Col>
                                    <Col span={SPAN_TWO_QUARTERS}>
                                        <Row align="middle" type="flex">
                                            <Col
                                                span={SPAN_ONE_QUARTER}><span>{t('scenes.mappingHandler.MappingSet.transcoding.mode')}</span></Col>
                                            <Col span={SPAN_THREE_QUARTERS}>
                                                <Select
                                                    defaultValue="load"
                                                    style={{width: '100%'}}
                                                    title={t('scenes.mappingHandler.MappingSet.transcoding.mode')}
                                                    onChange={(e) => onSetTrancodingMode(e)}
                                                >
                                                    <Select.Option key={'option_transcoding_load'}
                                                                   value="load">{t('scenes.mappingHandler.MappingSet.transcoding.modalityLoad')}</Select.Option>
                                                    <Select.Option key="option_trancoding_import"
                                                                   value="import">{t('scenes.mappingHandler.MappingSet.transcoding.modalityImport')}</Select.Option>
                                                </Select>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row style={{marginBottom: MARGIN_MD}}>
                                    <Col span={SPAN_TWO_QUARTERS}
                                         style={{display: 'flex', flexDirection: 'row', gap: GUTTER_MD}}>
                                        <Tooltip
                                            title={t("scenes.mappingHandler.MappingSet.transcoding.tooltip.codeMatchButton")}>
                                            <Button type="primary" onClick={()=> onCodeMatch(dataTable, triplet, data ? data.columnName[0]:"")}
                                                    disabled={(!!columnDataset && columnDataset.length > 1)}>{t("scenes.mappingHandler.MappingSet.transcoding.buttons.match")}</Button>
                                        </Tooltip>
                                        <Tooltip
                                            title={t("scenes.mappingHandler.MappingSet.transcoding.tooltip.synchronizeButton")}>
                                            <Button type="primary"
                                                    onClick={() => onGetDataFromCodelist(triplet)}
                                            >{t("scenes.mappingHandler.MappingSet.transcoding.buttons.synchronize")}</Button>
                                        </Tooltip>
                                        <Tooltip
                                            title={t("scenes.mappingHandler.MappingSet.transcoding.tooltip.exportTranscodingButton")}>
                                            <Button
                                                onClick={() => downloadCSVFile(dataTable, data ? data.dsdColumnName : "")}>{t("scenes.mappingHandler.MappingSet.transcoding.buttons.export")}</Button>
                                        </Tooltip>
                                    </Col>
                                    <Col span={SPAN_TWO_QUARTERS}>
                                        {mode === 'import' &&
                                            <FileInput
                                                value={fileName}
                                                style={{marginBottom: 5}}
                                                onChange={async (e) => {
                                                    const data = await handleFileUpload(e);
                                                    setCSVData(data);
                                                    setFileName(e)
                                                }}
                                                accept={".csv"}
                                            />
                                        }
                                    </Col>
                                </Row>
                                <Row style={{marginBottom: MARGIN_MD}}>
                                    {mode === 'import' &&
                                        <Col span={SPAN_FULL} style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'flex-end'
                                        }}>
                                            <Tooltip
                                                title={t("scenes.mappingHandler.MappingSet.transcoding.tooltip.importButton")}>
                                                <Button onClick={() => onImportTranscodingCSV(csvData, t)}
                                                        icon="download"
                                                        disabled={!fileName}
                                                        type="primary">{t('commons.buttons.import.title')}</Button>
                                            </Tooltip>
                                        </Col>
                                    }
                                </Row>
                                <Row style={{marginBottom: MARGIN_MD}} type="flex">
                                    <Col span={SPAN_FULL}>
                                        <span>{t("scenes.mappingHandler.MappingSet.transcoding.mappingCard")}</span>
                                        <Card style={{marginTop: MARGIN_XS}} bodyStyle={{padding: PADDING_XS}}>
                                            <Row type="flex" gutter={GUTTER_XS}>
                                                <Col span={SPAN_HALF} style={{
                                                    paddingRight: PADDING_SM,
                                                    borderRight: "1px solid #e5e5e5"
                                                }}>
                                                    <span
                                                        style={{fontWeight: "bold"}}>{t("scenes.mappingHandler.MappingSet.transcoding.localDatabaseColumns")}</span>
                                                    <div style={{maxHeight: "40px", overflow: "auto"}}>
                                                        <span>{!!data && _.join(_.map(data.dataset_column, 'name'), ', ')}</span>
                                                    </div>
                                                </Col>
                                                <Col span={SPAN_HALF} style={{paddingLeft: PADDING_SM}}>
                                                    <span
                                                        style={{fontWeight: "bold"}}>{t("scenes.mappingHandler.MappingSet.transcoding.SMDX")}</span>
                                                    <div style={{maxHeight: "40px", overflow: "auto"}}>
                                                        <span>{!!data && data.dsdColumnName}</span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row tyle={{marginBottom: MARGIN_MD}}>
                                    <Col span={SPAN_FULL}>
                                        <span>{t("scenes.mappingHandler.MappingSet.transcoding.rules")}</span>
                                        <RulesTableTranscoding languageSelector={languageSelector}/>
                                    </Col>
                                </Row>
                            </EnhancedModal>
                        </Call>
                    </Call>
                    <DSDComponentModal/>
                </Fragment>
            )
        }}
    </DataLanguageConsumer>)
};

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(TranscodingDimension);
